<template>
  <div>
    <v-row class="ml-n15 mt-n1">
      <div class="selectors-box">
        <div class="select-row">
          <div class="marginTop"></div>

          <v-select
            class="selector-time"
            v-model="selectedTimePeriod"
            :items="timePeriodArray"
            color="tertiary"
            @change="
              deleteDays()
              selectedTimesPeriods()
            "
          >
            >
            <template v-slot:label>
              <span v-if="selectedTimePeriod" class="label">Programación </span>
              <span v-else>Programación</span>
            </template>
          </v-select>
        </div>
      </div>
      <v-col
        :cols="screenSize ? '12' : null"
        v-if="selectedTimePeriod == 'Diario' || selectedTimePeriod == 'Semanal'"
        class="daysBox"
      >
        <span class="daysBox-text">Se repite el</span>
        <div>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('monday')"
            v-bind:color="monday.on ? '#0083ff' : '#E8E8E8'"
          >
            <template>
              <span v-bind:class="monday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >L</span
              >
            </template>
          </v-btn>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('tuesday')"
            v-bind:color="tuesday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span v-bind:class="tuesday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >M</span
              >
            </template>
          </v-btn>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('wednesday')"
            v-bind:color="wednesday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span
                v-bind:class="wednesday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >M</span
              >
            </template>
          </v-btn>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('thursday')"
            v-bind:color="thursday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span
                v-bind:class="thursday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >J</span
              >
            </template>
          </v-btn>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('friday')"
            v-bind:color="friday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span v-bind:class="friday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >V</span
              >
            </template>
          </v-btn>
          <v-btn
            class="ml-2 mb-n2"
            textclass="mx-2"
            fab
            x-small
            v-cloak
            @click="selectDay('saturday')"
            v-bind:color="saturday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span
                v-bind:class="saturday.on ? 'dayLetterOn ' : ' dayLetterOff'"
                >S</span
              >
            </template>
          </v-btn>
          <v-btn
            textclass="mx-2"
            class="ml-2 mb-n2"
            fab
            x-small
            v-cloak
            @click="selectDay('sunday')"
            v-bind:color="sunday.on ? '#0083ff ' : '#E8E8E8'"
          >
            <template>
              <span v-bind:class="sunday.on ? 'dayLetterOn ' : 'dayLetterOff'"
                >D</span
              >
            </template>
          </v-btn>
        </div>
      </v-col>
      <v-col v-if="selectedTimePeriod == 'Mensual'" md="3" class="ml-8">
        <v-select
          v-model="selectedCloseDay"
          @change="selectedTimesPeriods"
          :items="closeDay"
          color="tertiary"
        >
          <template v-slot:label>
            <span v-if="selectedCloseDay" class="blue--text"
              >Dia de cierre</span
            >
            <span v-else>Dia de cierre</span>
          </template>
        </v-select>
      </v-col>
      <h5
        v-if="selectedTimePeriod == 'Quincenal'"
        class="informative-text-quin"
      >
        *Repite el 1er día de la quincena (1ro y 16 del mes)
      </h5>
      <h5 v-if="selectedTimePeriod == 'Mensual'" class="informative-text">
        *Repite el día {{ selectedCloseDay }} de cada mes
      </h5>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ProgramReport',
  props: {
    sendSelectedTimesPeriods: {
      type: Function
    }
  },

  data() {
    return {
      selectedDaysNumberArray: '',
      daysNumberArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      monday: { day: 'monday', on: true, dayNumber: 1 },
      tuesday: { day: 'tuesday', on: true, dayNumber: 2 },
      wednesday: { day: 'wednesday', on: true, dayNumber: 3 },
      thursday: { day: 'thursday', on: true, dayNumber: 4 },
      friday: { day: 'friday', on: true, dayNumber: 5 },
      saturday: { day: 'saturday', on: true, dayNumber: 6 },
      sunday: { day: 'sunday', on: true, dayNumber: 0 },
      selectedTimePeriod: 'Diario',
      timePeriodArray: ['Diario', 'Semanal', 'Mensual', 'Quincenal'],
      selectedCloseDay: 1,
      closeDay: [1, 2, 3, 4, 5],
      objData: { run_periodicity: null, run_weekdays: null, run_monthday: null }
    }
  },

  methods: {
    selectedTimesPeriods() {
      const objData = {
        run_periodicity: this.selectedTimePeriod,
        run_weekdays:
          this.selectedTimePeriod == 'Semanal' ||
          this.selectedTimePeriod == 'Diario'
            ? this.selectedDaysSend()
            : null,
        run_monthday:
          this.selectedTimePeriod == 'Mensual' ? this.selectedCloseDay : null
      }

      this.sendSelectedTimesPeriods(objData)
    },
    deleteDays() {
      const days = [
        this.monday,
        this.tuesday,
        this.wednesday,
        this.thursday,
        this.friday,
        this.saturday,
        this.sunday
      ]
      days.map(e => (e.on = false))
    },

    selectedDaysSend() {
      //this.selectedTimePeriod == 'Semanal' ? (this.monday.on = true) : null

      const days = [
        this.monday,
        this.tuesday,
        this.wednesday,
        this.thursday,
        this.friday,
        this.saturday,
        this.sunday
      ]
      let selected = []
      days.map(day => (day.on == true ? selected.push(day.dayNumber) : null))
      return selected
    },

    selectDay(day) {
      const days = [
        this.monday,
        this.tuesday,
        this.wednesday,
        this.thursday,
        this.friday,
        this.saturday,
        this.sunday
      ]
      days.map(e => {
        if (e.day == day) {
          e.on = !e.on
        } else {
          if (this.selectedTimePeriod == 'Diario') {
            null
          } else {
            e.on = false
          }
        }
      })
      this.selectedTimesPeriods()
    }
  },

  watch: {
    selectedTimePeriod() {
      const days = [
        this.monday,
        this.tuesday,
        this.wednesday,
        this.thursday,
        this.friday,
        this.saturday,
        this.sunday
      ]
      if (this.selectedTimePeriod == 'Diario') days.map(e => (e.on = true))
      if (this.selectedTimePeriod == 'Semanal') {
        this.monday.on = true
      }
    }
  },
  computed: {
    screenSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true
        case 'sm':
          return true

        default:
          false
      }
    }
  },
  mounted() {
    this.selectedTimesPeriods()
  },
  updated() {
    //this.showSearchInput()
  }
}
</script>

<style scoped>
.buttonPressed {
  height: 40;
  width: 20;
  background-color: #0083ff;
}
.button {
  height: 3em;
  max-width: 3em;
  border-radius: 50%;
  display: block;
  background-color: #e8e8e8;
}
.dayLetterOn {
  color: white;
}
.dayLetterOff {
  color: #939393;
}
.daysBox-text {
  align-self: flex-start;
  color: #0083ff;
  font-size: 0.75em;
  margin-top: 0.2em;
}
.daysBox {
  display: flex;
  flex-direction: column;
  height: 3.5em;
  justify-content: space-between;
  margin-left: 1.5em;
}
.marginTop {
  height: 1.4px;
  width: 1em;
}
.mw {
  max-width: 3em;
  margin-top: 1.05em;
  margin-left: 2em;
}

.select-row {
  display: flex;
  flex-direction: row;
  max-height: 1.5em;
  align-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.selector-time {
  max-width: 7em;
  margin-top: 1.05em;
  margin-left: -0.7em;
}
.selectors-box {
  margin-top: 1.88em;
  max-height: 3em;
  margin-left: 1.5em;
}
.selectors-text {
  position: relative;
  top: 0.5em;
  align-self: flex-start;
  color: #0083ff;
  font-size: 0.75em;
  align-self: center;
  margin-left: 2.8em;
}
.informative-text {
  align-self: center;
  margin-left: 2em;
  color: #0083ff;
}
.informative-text-quin {
  align-self: center;
  margin-left: 2em;
  margin-top: 2em;
  color: #0083ff;
}
</style>
